import * as React from 'react';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './ConfirmModal.styl';
class ConfirmModal extends React.Component {
    render() {
        const { onAccept, onDecline } = this.props;
        return (React.createElement("div", { className: styles.confirmModal },
            React.createElement("div", { className: styles.content },
                React.createElement("h4", { className: styles.heading }, "Confirmation"),
                React.createElement("p", { className: styles.text }, "Are you sure you want to do this?")),
            React.createElement("div", { className: styles.controls },
                React.createElement(Button, { className: styles.decline, variant: 'tonal', onClick: onDecline }, "Decline"),
                React.createElement(Button, { className: styles.confirm, variant: 'filled', onClick: onAccept }, "Confirm"))));
    }
}
Object.defineProperty(ConfirmModal, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        onAccept: () => { },
        onDecline: () => { }
    }
});
export default ConfirmModal;
